import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Toast } from './../UI/toast/Toast';
import { Button, Form, FormGroup, Input } from 'reactstrap';
import withRedirect from '../../helpers/hoc/withRedirect';
import { useSelector } from 'react-redux';
import { forgotPasswordRequest } from '../../helpers/api/auth';

const ForgetPasswordForm = ({ setRedirect, setRedirectUrl }) => {
  const [email, setEmail] = useState('');
  const { isLoading } = useSelector(state => state.auth)

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (email) {
      try {
        await forgotPasswordRequest(email);
        Toast.fire({
          type: 'success',
          title: `Un link ha sido enviado a ${email}`,
        });
        setRedirect(true);
      } catch (error) {
        Toast.fire({
          type: 'error',
          title: `Ha ocurrido un error, espere un momento`,
        });
      }
    }
  }

  useEffect(() => {
    setRedirectUrl(`/authentication/confirm-mail?type=forgot&email=${email}`);
  }, [email, setRedirectUrl]);


  return (
    <Form className="mt-4" onSubmit={handleSubmit}>
      <FormGroup>
        <Input
          className="form-control"
          placeholder="Correo electrónico"
          value={email}
          onChange={({ target }) => setEmail(target.value)}
          type="email"
        />
      </FormGroup>
      <FormGroup>
        <Button color="primary" block disabled={!email || isLoading}>
          Enviar
        </Button>
      </FormGroup>
    </Form>
  )
}

ForgetPasswordForm.propTypes = {
  setRedirect: PropTypes.func.isRequired,
  setRedirectUrl: PropTypes.func.isRequired,
  layout: PropTypes.string
};

export default withRedirect(ForgetPasswordForm);